export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  const api = $fetch.create({
    baseURL: config.public.baseApiUrl,
    onRequest({ options }) {
      // Get current locale from i18n
      const i18n = nuxtApp.$i18n
      const currentLocale = i18n?.locale?.value || 'ru'

      // Get token securely. ofetch re-runs onRequest on a retry after a failed request,
      // outside the Nuxt context, so useCookie needs the context restored explicitly
      const tokenCookie = nuxtApp.runWithContext(() =>
        useCookie('auth-token', {
          default: () => null,
          secure: true,
          httpOnly: false,
          sameSite: 'strict'
        })
      )

      const token = tokenCookie.value

      // ofetch passes the caller's headers as a Headers instance: spreading it into an object
      // would drop them, so the common headers are set on it instead
      const headers = new Headers(options.headers)
      headers.set('Accept-Language', currentLocale)
      for (const [name, value] of Object.entries(visitorIpHeaders(nuxtApp))) {
        headers.set(name, value)
      }
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      options.headers = headers
    },
    async onResponseError({ request, options, response }) {
      // Handle 401 Unauthorized responses
      if (response.status === 401) {
        const { clearUser, refreshToken } = useUser()

        const requestUrl = typeof request === 'string' ? request : request.url

        // For password change specifically, don't clear user - let error bubble up
        if (requestUrl.includes('/user/password')) {
          return
        }

        // Don't try to refresh token for auth endpoints - clear user and return
        if (
          requestUrl.includes('/login') ||
          requestUrl.includes('/register') ||
          requestUrl.includes('/refresh-token') ||
          requestUrl.includes('/password/') ||
          requestUrl.includes('/reset-password') ||
          requestUrl.includes('/forgot-password')
        ) {
          clearUser()
          return
        }

        // Try to refresh token for other protected endpoints
        try {
          const newToken = await refreshToken()

          if (newToken && options.headers) {
            const headers = new Headers(options.headers)
            headers.set('Authorization', `Bearer ${newToken}`)
            options.headers = headers
            return $fetch(request, options)
          }
        } catch {
          // Token refresh failed
        }

        // Clear user if refresh failed or no new token
        clearUser()
      }
    }
  })

  return {
    provide: {
      api
    }
  }
})
